import {
  Box,
  Card,
  formatMinutes,
  formatSchoolYear,
  Grid,
  idToColor,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
} from "@compass/core";
import { ObjectiveReportsProjectServices, ObjectiveReportsProjectServicesTableRow } from "generated/openApi";
import { Chart, Export, Label, Legend, Series, Tooltip, ValueAxis, VisualRange } from "devextreme-react/chart";
import { DevExpressReport } from "components";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { Column } from "devextreme-react/data-grid";

export const ObjectiveProjectServices = (props: { title: string; objective: ObjectiveReportsProjectServices }) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const renderChart = () => {
    return (
      <Chart
        id="chart"
        width="100%"
        dataSource={props.objective.rows}
        customizePoint={(args: any) => {
          return { color: idToColor(args.data.serviceTypeId) };
        }}
        onPointHoverChanged={(pointInfo: any) => {
          if (pointInfo.target.isHovered()) {
            pointInfo.target.showTooltip();
          } else {
            pointInfo.target.hideTooltip();
          }
        }}
      >
        <Series
          argumentField={pn<ObjectiveReportsProjectServicesTableRow>("serviceType")}
          valueField={pn<ObjectiveReportsProjectServicesTableRow>("studentCount")}
          type="bar"
        ></Series>

        <Tooltip
          enabled={false}
          customizeTooltip={(arg) => {
            return {
              text: `${arg.point.data.serviceType}<br/>` + `Students: ${arg.point.data.studentCount}<br/>`,
            };
          }}
        />

        <ValueAxis>
          <VisualRange startValue={0} />
          <Label customizeText={(arg) => `${arg.valueText}`} />
        </ValueAxis>
        <Legend visible={false} />
        <Export enabled={true} />
      </Chart>
    );
  };

  const renderTable = () => {
    return (
      <DevExpressReport
        dataSource={props.objective.rows}
        fullPageSize
        showColumnChooser={false}
        exportFormats={["pdf", "excel", "csv"]}
        onExporting={() => {
          return {
            header: "Services",
            filename: "Services",
            tenantName: appTenantName,
          };
        }}
      >
        <Column dataField={pn<ObjectiveReportsProjectServicesTableRow>("serviceType")} />
        <Column dataField={pn<ObjectiveReportsProjectServicesTableRow>("studentCount")} />
      </DevExpressReport>
    );
  };

  return (
    <Card header={props.title}>
      <Box>
        <Grid ref={breakpointsRef} container spacing="lg">
          <Grid item xs={setBreakpoints({ md: 8, xs: 12 })}>
            {renderChart()}
          </Grid>

          <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
            {renderTable()}
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};
